import { useTranslation } from "react-i18next";
import spmlogo from "../../resources/img/spmlogo.png";

const ClosedForPatients = ({ errorMessage, loading }) => {
  const { t } = useTranslation();

  return (
    <div className="w3-display-container content-container content-container-full">
      <div className="title-view">
        {errorMessage}
        <div className="w3-center form-display-drugs medication-content">
          <div className="w3-panel w3-card-4 record-panel">
            <div className="alert-banner w3-padding-small w3-margin-bottom">
              <p className="alert-banner-text">
                ⚠️ {t("closed_for_patients")}
              </p>
            </div>
            <img src={spmlogo} alt="SPM logo" className="spm-logo w3-margin-top w3-margin-bottom" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClosedForPatients;
